import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';
import { breakpoints, colors } from '../../../utils/styleguide';
import Typography from '../text/Typography';

const TRANSITION_DURATION = '300ms';

const Wrapper = styled.div`
  align-items: center;
  background-color: ${colors.lightGray};
  border: 2px solid ${colors.lightGray};
  display: flex;
  height: 40px;
  justify-content: space-around;
  position: relative;
  width: 100%;

  ${breakpoints.desktop} {
    height: 46px;
  } ;
`;

const sliderTransition = ({ positionInPercentage }: { positionInPercentage: number }) =>
  css`
    transform: translateX(${positionInPercentage}%);
  `;

const Slider = styled.div`
  background-color: ${colors.green200};
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transition: transform ${TRANSITION_DURATION};
  width: 50%;
  z-index: 5;
  ${sliderTransition}
`;

const RadioButton = styled.input`
  position: absolute;
  appearance: none;
  background-color: transparent;
  border: none;
  height: 100%;
  margin: 0;
  outline: none;
  text-align: center;
  width: 100%;
  z-index: 15;
`;

const optionTextTransition = ({ color }: { color: string }) =>
  css`
    color: ${color};
  `;

const OptionText = styled(Typography)`
  line-height: 1;
  color: ${colors.black};
  transition: color ${TRANSITION_DURATION};
  ${optionTextTransition}
`;

const ButtonWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  width: 100%;
  height: 100%;
`;

export type Option = { value: string; label: string };

type Props = {
  className?: string;
  value: string;
  onChange: (value: string) => void;
  options: [Option, Option];
};

const Switch = ({ className, value, onChange, options }: Props) => {
  function handleToggle(clickedValue: string) {
    if (value !== clickedValue) {
      onChange(clickedValue);
    }
  }

  return (
    <Wrapper className={className}>
      <Slider positionInPercentage={value === options[1].value ? 100 : 0} />

      <ButtonWrapper>
        <RadioButton
          type="radio"
          name="options"
          value={options[0].value}
          onChange={() => handleToggle(options[0].value)}
        />
        <OptionText
          color={value === options[0].value ? colors.black : colors.darkGray}
          variant="bodySmallBold"
          style={{ lineHeight: 1 }}
        >
          {options[0].label}
        </OptionText>
      </ButtonWrapper>

      <ButtonWrapper>
        <RadioButton
          type="radio"
          name="options"
          value={options[1].value}
          onChange={() => handleToggle(options[1].value)}
        />
        <OptionText
          color={value === options[1].value ? colors.black : colors.darkGray}
          variant="bodySmallBold"
          style={{ lineHeight: 1 }}
        >
          {options[1].label}
        </OptionText>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default Switch;
